import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import useRetrieveActiveContractIdAndType from '@/containers/SubscriptionFormPageNew/Layouts/useRetrieveActiveContractIdAndType'
import { selectCharacteristicsCurrentContractActive } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import {
  PRESTATION_TYPE_FMES,
  PRESTATION_TYPE_NEW_CONNECTION,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

const BUILDING_PERMIT_PRESTATION_TYPES = [PRESTATION_TYPE_FMES, PRESTATION_TYPE_NEW_CONNECTION]

export const isBuildingPermitDataComplete = (buildingPermitData: Record<string, any>) =>
  !!buildingPermitData?.building_permit_option

const useBuildingPermitValidation = () => {
  const { t } = useTranslation()
  const { country } = useSelector(selectAuthData)
  const { addErrorToContract, removeContractError } = useFormStatus()
  const { id } = useRetrieveActiveContractIdAndType()
  const { prestationType } = useSelector(selectCharacteristicsCurrentContractActive)

  const validateBuildingPermitData = (address: Record<string, any>, providerConfig: Record<string, any>) => {
    if (country !== 'it') return
    if (
      providerConfig?.buildingPermitFieldsMandatory &&
      BUILDING_PERMIT_PRESTATION_TYPES.includes(prestationType) &&
      !isBuildingPermitDataComplete(address.buildingPermitData ?? {})
    ) {
      addErrorToContract(id, {
        building_permit_data: t('subscriptionForm:address_module.building_permit_fields.missing_data_error'),
      })
      return
    }
    removeContractError(id, 'building_permit_data')
  }

  return { validateBuildingPermitData }
}

export default useBuildingPermitValidation
